import { useSelector } from 'react-redux';
import { sessionSelectors } from 'modules/session';

export const AdminOnly = ({ children }) => {
  const isAdmin = useSelector(sessionSelectors.getIsAdmin);

  if (!isAdmin) return null;

  return children;
};
